import { BrowserModule, Meta } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, LOCALE_ID, ErrorHandler, Injectable } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatExpansionModule } from '@angular/material/expansion';
import * as Sentry from '@sentry/angular-ivy';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

import localeFr from '@angular/common/locales/es-AR';
import { registerLocaleData } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
registerLocaleData(localeFr);

import { MatCardModule } from '@angular/material/card';
import { SharedModule } from './modules/shared/shared.module';
import { LazyLoadDirective } from './utils/directives/lazy-load-directive.directive';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { TokenInterceptor } from './pages/core/utils/token.interceptor';
import { Router } from '@angular/router';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
export const playerFactory = () => {
  return player;
};

@NgModule({
  declarations: [AppComponent, LazyLoadDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatExpansionModule,
    MarkdownModule.forRoot({
      loader: HttpClient,
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,
    NgxChartsModule,
    MatCardModule,
    MatTooltipModule,
    SharedModule,
    NativeDateModule,
    NgxMaskModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    RecaptchaV3Module,
  ],
  exports: [],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.captchaKey,
    },
    Meta,
    { provide: LOCALE_ID, useValue: 'es-AR' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
